import React, { FC } from 'react';
import { Theme, Box, Typography, makeStyles, Container } from '@material-ui/core';
import { bgImageLeadership, leadership } from 'images/about-us';
import Image from 'blog/components/Image';

interface LeadershipSectionProps {
  title: string;
  secondTitle: string;
  text: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    paddingTop: theme.spacing(26),
    backgroundImage: `url(${bgImageLeadership})`,
    backgroundPosition: 'left',
  },
  title: {
    fontWeight: 500,
    color: theme.palette.primary.dark,
  },
  divider: {
    width: 100,
    height: 1,
    backgroundColor: theme.palette.primary.main,
    marginTop: theme.spacing(6),
  },
  image: {
    margin: theme.spacing(26, 0, 12),
  },
  secondTitle: {
    fontWeight: 500,
    color: theme.palette.primary.dark,
    paddingLeft: theme.spacing(2),
    borderLeft: '5px solid #E0621E',
    marginBottom: theme.spacing(5),
  },
}));
const LeadershipSection: FC<LeadershipSectionProps> = ({ title, secondTitle, text }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root} data-aos="fade-up" data-aos-delay="200">
      <Container fixed>
        <Typography variant="h2" className={classes.title} align="center">
          {title}
        </Typography>
        <Box className={classes.divider} margin="0 auto" />
        <Image src={leadership} alt="1" width={1170} height={310} layout="responsive" className={classes.image} />
        <Typography variant="h2" className={classes.secondTitle}>
          {secondTitle}
        </Typography>
        <Typography variant="body1" id={'team'}>
          {text}
        </Typography>
      </Container>
    </Box>
  );
};
export default LeadershipSection;
